module.exports = __webpack_public_path__ + "img/icon331.a32df381.png";